// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.header-avail-slots-container {
  display: flex;
}
.header-avail-slots-container #text {
  color: #0A4064;
  font-weight: 650;
}
.header-avail-slots-container .header-item-container {
  border: 1px solid #A7A9AC;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 20%;
  padding: 8px 20px;
  background: #C0DEF0;
  font-weight: 500;
  font-size: 1.1rem;
}

.avail-slots-container {
  display: flex;
}
.avail-slots-container .item-container {
  border-top: 1px solid #D1D3D4;
  border-bottom: 1px solid #D1D3D4;
  border-left: 1px solid #D1D3D4;
  border-right: 1px solid #D1D3D4;
  display: flex;
  align-items: center;
  height: 100px;
  width: 20%;
  padding: 8px 20px;
  font-weight: 500;
}
.avail-slots-container .item-container input[type=text] {
  border-radius: 5px;
  border: none;
  border: 1px solid #808080;
  padding: 5px;
  padding-left: 10px;
  max-width: 100px;
}
.avail-slots-container .grade-font {
  font-weight: 600;
  font-size: 1rem;
  color: #0669B3;
}
.avail-slots-container .numbers {
  font-weight: 600;
}

.disabled-input {
  background: #D1D3D4;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/AvailableSlotsRow.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANA;EACI,aAAA;AASJ;AARI;EACI,cDQE;ECPF,gBAAA;AAUR;AAPI;EACI,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,UAAA;EACA,iBAAA;EACA,mBDSI;ECRJ,gBAAA;EACA,iBAAA;AASR;;AANA;EACI,aAAA;AASJ;AAPI;EACI,6BAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;AASR;AAPQ;EClCJ,kBAgCsB;EACtB,YAAA;EACA,yBAAA;EACA,YAAA;EDCQ,kBAAA;EACA,gBAAA;AAYZ;AARI;EACI,gBAAA;EACA,eAAA;EACA,cDnBK;AC6Bb;AARI;EACI,gBAAA;AAUR;;AANA;EACI,mBDpCI;ECqCJ,YAAA;AASJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n\n.header-avail-slots-container {\n    display: flex;\n    #text {\n        color: $dk-blue;\n        font-weight: 650;\n    }\n\n    .header-item-container {\n        border: 1px solid $grey2;\n        border-top-left-radius: 10px;\n        border-top-right-radius: 10px;\n        width: 20%;\n        padding: 8px 20px;\n        background: $pale-blue;\n        font-weight: 500;\n        font-size: 1.1rem;\n    }\n}\n.avail-slots-container {\n    display: flex;\n\n    .item-container {\n        border-top: 1px solid $grey1;\n        border-bottom: 1px solid $grey1;\n        border-left: 1px solid $grey1;\n        border-right: 1px solid $grey1;\n        display: flex;\n        align-items: center;\n        height: 100px;\n        width: 20%;\n        padding: 8px 20px;\n        font-weight: 500;\n\n        input[type=\"text\"] {\n            @include standardInput;\n            padding-left: 10px;\n            max-width: 100px;\n        }\n\n    }\n    .grade-font {\n        font-weight: 600;\n        font-size: 1rem;\n        color: $pearl-blue;\n    }\n    .numbers {\n        font-weight: 600;\n    }\n}\n\n.disabled-input {\n    background: $grey1;\n    color: black;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
